module.exports = __webpack_public_path__ + "img/product_36.16e4584.webp";